import ls from "local-storage";

export const CsvVenta= (concepto, data)=>{
    switch(concepto){
        case "upc":
            return generarDataUpc(data);
        case "categoria":
            return generarDataCategoria(data);
        case "id_compra":
            return generarDataIdCompra(data);
        case "publisher":
            return generarDataPublisher(data);
        case "dataDetalle":
            return generarDataDetalle(data);
        default:
        break;
    }
}

function generarDataUpc(data){
    let dat = [];
    dat = data.map(x => (
        {
          "UPC": x.upc,
          "Producto": x.nombre,
          "Plataforma": x.plataforma,
          "Categoria": x.categoria,
          "Publisher": x.publisher,
          "Compras Acumuladas": x.unidades_iniciales,
          "Venta Perido (Unidades)": x.unidades_periodo,
          "Inventario en (Tienda + Almacen)": x.unidades_restantes,
          "Ventas del Periodo $": x.periodo_venta,
          "Costo de Venta $": x.periodo_costo,
          "IVA del costo de venta $": x.periodo_iva,
          "IEPS del costo de venta $": x.periodo_ieps,
          "Pagado": x.periodo_pago_proveedor,
          "Costo % Venta del Periodo": x.periodo_costo_promedio_unidad_vendida,
          "Costo % Factura del Periodo": x.periodo_costo_promedio_unidad_factura_inicial,
          "Precio Actual Tiendas Físicas": x.precio_actual_tiendas,
          "Comisión para GP": x.acordado_comision,
          "IVA del costo de la venta %": x.acordado_iva,
          "IEPS del costo de la venta %": x.acordado_ieps
        }));
    return dat;
}

function generarDataCategoria(data){
    let dat = [];
    dat = data.map(x => (
        {
          "Categoria": x.categoria,
          "Compras Acumuladas": x.unidades_iniciales,
          "Venta Perido (Unidades)": x.unidades_periodo,
          "Inventario en (Tienda + Almacen)": x.unidades_restantes,
          "Ventas del Periodo $": x.periodo_venta,
          "Costo de Venta $": x.periodo_costo,
          "IVA del costo de venta $": x.periodo_iva,
          "IEPS del costo de venta $": x.periodo_ieps,
          "Pagado": x.periodo_pago_proveedor,
          "Costo % Venta del Periodo": x.periodo_costo_promedio_unidad_vendida,
          "Costo % Factura del Periodo": x.periodo_costo_promedio_unidad_factura_inicial,
          "Precio Actual Tiendas Físicas": x.precio_actual_tiendas,
          "Comisión para GP": x.acordado_comision,
          "IVA del costo de la venta %": x.acordado_iva,
          "IEPS del costo de la venta %": x.acordado_ieps
        }));
    return dat;
}

function generarDataIdCompra(data){
    let dat = [];
    dat = data.map(x => (
        {
          "Id Compra": x.id_compra,
          "No Factura": x.no_factura,
          "Fecha Compra Efectiva": x.fecha_compra_efectiva,
          "Titulos": x.titulos,
          "Compra Lote": x.compra_lote,
          "Compras Acumuladas": x.unidades_iniciales,
          "Venta Perido (Unidades)": x.unidades_periodo,
          "Inventario en (Tienda + Almacen)": x.unidades_restantes,
          "Ventas del Periodo $": x.periodo_venta,
          "Costo de Venta $": x.periodo_costo,
          "IVA del costo de venta $": x.periodo_iva,
          "IEPS del costo de venta $": x.periodo_ieps,
          "Pagado": x.periodo_pago_proveedor,
          "Costo % Venta del Periodo": x.periodo_costo_promedio_unidad_vendida,
          "Costo % Factura del Periodo": x.periodo_costo_promedio_unidad_factura_inicial,
          "Precio Actual Tiendas Físicas": x.precio_actual_tiendas,
          "Comisión para GP": x.acordado_comision,
          "IVA del costo de la venta %": x.acordado_iva,
          "IEPS del costo de la venta %": x.acordado_ieps
        }));
    return dat;
}

function generarDataPublisher(data){
    let dat = [];
    dat = data.map(x => (
        {
          "Id Publisher": x.id_publisher,
          "Publisher": x.publisher,
          "Compras Acumuladas": x.unidades_iniciales,
          "Venta Perido (Unidades)": x.unidades_periodo,
          "Inventario en (Tienda + Almacen)": x.unidades_restantes,
          "Ventas del Periodo $": x.periodo_venta,
          "Costo de Venta $": x.periodo_costo,
          "IVA del costo de venta $": x.periodo_iva,
          "IEPS del costo de venta $": x.periodo_ieps,
          "Pagado": x.periodo_pago_proveedor,
          "Costo % Venta del Periodo": x.periodo_costo_promedio_unidad_vendida,
          "Costo % Factura del Periodo": x.periodo_costo_promedio_unidad_factura_inicial,
          "Precio Actual Tiendas Físicas": x.precio_actual_tiendas,
          "Comisión para GP": x.acordado_comision,
          "IVA del costo de la venta %": x.acordado_iva,
          "IEPS del costo de la venta %": x.acordado_ieps
        }));
    return dat;
}

function generarDataDetalle(data){
    let dat = [];
    dat = data.map(x => (
        {
            "Id Venta": x.id_venta,
            "Fecha": x.fecha,
            "UPC": x.upc,
            "Producto": x.nombre,
            "Plataforma": x.plataforma,
            "Categoria": x.categoria,
            "Publisher": x.publisher,
            "Id_Caja": ls.get("admin")?x.id_caja:"", //genera "Columna" Id_Caja llena o vacia
            "Id Compra": x.id_compra,
            "Lote": x.lote,
            "Tipo Compra": x.tipo_calculo,
            "Ventas Periodo (Unidades)": x.unidades,
            "Ventas del Periodo $": x.periodo_venta,
            "Costo de Venta $": x.periodo_costo,
            "IVA del costo de venta $": x.periodo_iva,
            "IEPS del costo de venta $": x.periodo_ieps,
            "Pagado": x.periodo_pago_proveedor,
            "Costo % Venta del Periodo": x.periodo_costo_promedio_unidad_vendida,
            "Costo % Factura del Periodo": x.periodo_costo_promedio_unidad_factura_inicial,
            "Precio Actual Tiendas Físicas": x.precio_actual_tiendas,
            "Comisión para GP": x.acordado_comision,
            "IVA del costo de la venta %": x.acordado_iva,
            "IEPS del costo de la venta %": x.acordado_ieps
        }));

    //Si no es admin elimina "columna" Id_Caja del array de objetos
    if(!ls.get("admin")){
        delete dat[0].Id_Caja;
    }
    return dat;
}